export enum ThreadRelatedObjectType {
  Customer = 1,
}
